<template>
  <nav class="bg-gray-800 md:flex">
    <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
      <div class="relative flex items-center justify-between h-16">
        <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
          <!-- Mobile menu button-->
          <button
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white transition duration-150 ease-in-out"
            aria-label="Main menu"
            aria-expanded="false"
            @click="isMenuOpen = !isMenuOpen"
          >
            <!-- Icon when menu is closed. -->
            <!-- Menu open: "hidden", Menu closed: "block" -->
            <svg
              :class="{ block: !isMenuOpen, hidden: isMenuOpen }"
              class=" h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <!-- Icon when menu is open. -->
            <!-- Menu open: "block", Menu closed: "hidden" -->
            <svg
              :class="{ block: isMenuOpen, hidden: !isMenuOpen }"
              class=" h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div
          class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start"
        >
          <div class="flex-shrink-0 items-center flex">
            <p class="text-white  flex items-center font-bold">
              CartHike
              <span class="headway-cont" />
            </p>
          </div>
          <div class="hidden md:ml-6 md:flex md:items-center">
            <router-link
              to="/carts"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Abandoned carts
            </router-link>

            <router-link
              to="/analytics"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Analytics
            </router-link>

            <router-link
              to="/automation"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out relative"
              exact-active-class="text-white bg-gray-900"
              >Automation
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800 ml-3"
              >
                New
              </span>
            </router-link>
            <router-link
              to="/chat"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Chat
            </router-link>
            <router-link
              to="/crm"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >CRM
            </router-link>

            <router-link
              to="/orders"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Orders
            </router-link>
            <!-- <router-link
              to="/marketing"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Marketing
            </router-link> -->
            <router-link
              to="/inbox"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Team Inbox
            </router-link>
            <router-link
              to="/integrations"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
              exact-active-class="text-white bg-gray-900"
              >Integrations
            </router-link>
          </div>
        </div>

        <div
          class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
        >
          <ProfileDropdown @showOnboarding="$emit('showOnboarding')" />
        </div>
      </div>
    </div>

    <div class=" sm:hidden" :class="{ block: isMenuOpen, hidden: !isMenuOpen }">
      <div class="px-2 pt-2 pb-3">
        <router-link
          to="/carts"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Abandoned carts
        </router-link>

        <router-link
          to="/analytics"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Analytics
        </router-link>
        <router-link
          to="/automation"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Automation
        </router-link>
        <router-link
          to="/chat"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Chat
        </router-link>
        <router-link
          to="/crm"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >CRM
        </router-link>
        <router-link
          to="/orders"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Orders
        </router-link>
        <router-link
          to="/inbox"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Team Inbox
        </router-link>
        <!-- <div
          @click="openInBrowser"
          class="ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          exact-active-class="text-white bg-gray-900"
        >
          Open In Browser
        </div> -->
        <!-- <router-link
          to="/semiautomation"
          class="block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
          >Semi automation
        </router-link> -->
      </div>
    </div>
    <div class="hidden md:flex items-center mr-3">
      <button
        v-if="shouldShowOpenAsTab"
        type="button"
        class="mr-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out inline-flex items-center"
        @click="openAppInNewTab"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
          />
        </svg>
        New tab
      </button>

      <OnboardingChecklist />
    </div>
  </nav>
</template>

<script>
import ProfileDropdown from "./ProfileDropdown";
import OnboardingChecklist from "../Onboarding/OnboardingChecklist.vue";

export default {
  name: "Topbar",
  components: {
    ProfileDropdown,
    OnboardingChecklist
  },
  data() {
    return {
      isMenuOpen: false,
      shouldShowOpenAsTab: false
    };
  },

  mounted() {
    this.initialHeadway();
    this.shouldShowOpenAsTab = this.isAnIframe();
  },
  methods: {
    initialHeadway() {
      const hwConfig = {
        selector: ".headway-cont", // CSS selector where to inject the badge
        account: "x9AaMx",
        enabled: true
      };
      // eslint-disable-next-line
      if (typeof Headway !== "undefined") {
        // eslint-disable-next-line
        Headway.init(hwConfig);
      }
    },
    isAnIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    openAppInNewTab() {
      const authToken = window.localStorage.getItem("authToken");
      if (authToken) {
        const origin = window.location.origin;

        window.open(`${origin}/#/?token=${authToken}`, "_blank");
      }
    },
    openInBrowser() {
      const authToken = window.localStorage.getItem("authToken");
      if (authToken) {
        const origin = window.location.origin;
        if (this.userAgent.indexOf("Shopify Mobile") > -1) {
          this.$store.dispatch("appBridgeRedirect", {
            url: `${origin}/#/auth/${authToken}`
          });
        } else {
          window.open(`${origin}/#/?token=${authToken}`, "_blank");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
